import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export const useTrackAppcuesPages = () => {
    let location = useLocation();
    const prevPath = useRef<string | null>();
    useEffect(() => {
        if (prevPath.current !== location.pathname) {
            // We want to call Appcues.page() only on path changes. Not search params changes.
            prevPath.current = location.pathname;
            window.Appcues?.page?.();
        }
    }, [location]);
};
